export const PASSWORD_CREATE_REQUEST = "PASSWORD_CREATE_REQUEST";
export const PASSWORD_CREATE = "PASSWORD_CREATE";

export const PASSWORD_RESET_REQUEST = "PASSWORD_RESET_REQUEST";
export const PASSWORD_RESET = "PASSWORD_RESET";
